const GETTERS = {
  currentColumns(state, getters, rootGetters) {
    return state.columns[rootGetters['tools/reportKey']] || []
  },
}

export default GETTERS
